import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const SLIDE_EMOJIS = ['🏪', '📷', '🪙']
const SLIDE_COUNT = 3

interface Props {
  onDismiss: () => void
}

export default function OnboardingCarousel({ onDismiss }: Props) {
  const { t } = useTranslation('gamification')
  const [slide, setSlide] = useState(0)
  const isLast = slide === SLIDE_COUNT - 1

  const handleNext = () => {
    if (isLast) {
      onDismiss()
    } else {
      setSlide((s) => s + 1)
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center p-6"
      style={{ background: 'rgba(0,0,0,0.65)' }}
    >
      <div
        className="w-full max-w-sm rounded-3xl p-8 flex flex-col items-center text-center"
        style={{ background: 'var(--app-card-bg)' }}
      >
        {/* Emoji */}
        <div style={{ fontSize: 64, lineHeight: 1, marginBottom: 20 }}>
          {SLIDE_EMOJIS[slide]}
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold mb-2" style={{ color: 'var(--tg-theme-text-color)' }}>
          {t(`onboarding.${slide}.title`)}
        </h2>

        {/* Subtitle */}
        <p className="text-sm opacity-60 leading-relaxed mb-8" style={{ color: 'var(--tg-theme-text-color)' }}>
          {t(`onboarding.${slide}.subtitle`)}
        </p>

        {/* Dot indicators */}
        <div className="flex gap-2 mb-8">
          {Array.from({ length: SLIDE_COUNT }).map((_, i) => (
            <div
              key={i}
              className="rounded-full transition-all duration-300"
              style={{
                width: i === slide ? 20 : 8,
                height: 8,
                background: i === slide ? 'var(--tg-theme-button-color)' : 'var(--app-page-bg)',
              }}
            />
          ))}
        </div>

        {/* Button */}
        <button
          className="w-full py-3 rounded-2xl font-semibold text-base"
          style={{
            background: 'var(--tg-theme-button-color)',
            color: 'var(--tg-theme-button-text-color)',
          }}
          onClick={handleNext}
        >
          {isLast ? t('onboarding.startEarning') : t('onboarding.next')}
        </button>
      </div>
    </div>
  )
}
